export default "__VITE_ASSET__DoXOBa42__"